import React, { FC } from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import { CustomerLogoFragmentFragment } from "@graphqlTypes"

const CustomerLogo: FC<CustomerLogoFragmentFragment> = ({ companyName, logo }) => (
  <>
    {(logo && logo.imgixImage) && (logo.imgixImage.gatsbyImageData ? (
      // Raster
      <GatsbyImage
        alt={companyName || ""}
        className="CustomerLogo"
        image={logo.imgixImage.gatsbyImageData}
      />
    ) : (
      // SVG
      <img
        alt={companyName || ""}
        className="CustomerLogo"
        height={118}
        loading="lazy"
        src={logo.imgixImage.url || ""}
        width={217}
      />
    ))}
  </>
)


export const CustomerLogoFragment = graphql`
  fragment CustomerLogoFragment on ContentfulCustomerLogo {
    companyName
    logo {
      imgixImage {
        gatsbyImageData(width: 216)
        url
      }
    }
    url
  }
`

export default CustomerLogo
